import * as React from 'react';
import './Table.scss';

import './Pager.scss';

interface IPagerProps {
    pageSize: number;
    pageNumber: number;
    totalRecords: number;
    currentPageCount: number;
    onPageChange?: (page: number) => void;
}

const Pager: React.StatelessComponent<IPagerProps> = (props) => {
    const firstRecord = (props.pageNumber - 1) * props.pageSize + 1;
    const recordText = `Showing ${firstRecord} to ${firstRecord + props.currentPageCount - 1} of ${props.totalRecords} records`;
    const totalPages = Math.ceil(props.totalRecords / props.pageSize);

    let prevClass = 'page-item';
    let nextClass = 'page-item';
    let prevClick: () => void = () => undefined;
    let nextClick: () => void = () => undefined;

    if (totalPages > 1) {
        if (props.pageNumber === 1) {
            prevClass += ' disabled';
        } else {
            prevClick = () => (props.onPageChange ? props.onPageChange(props.pageNumber - 1) : undefined);
        }

        if (props.pageNumber === totalPages) {
            nextClass += ' disabled';
        } else {
            nextClick = () => (props.onPageChange ? props.onPageChange(props.pageNumber + 1) : undefined);
        }
    }

    const pager = (
        <div className="table-pager" style={{ marginTop: '2rem' }}>
            <div
                className="pager-wrapper"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem 2rem',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <div style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>{recordText}</div>
                {
                    props.totalRecords > props.pageSize && (
                        <div>
                            <nav>
                                <ul className="pagination" style={{ display: 'flex', gap: '0.75rem', listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li
                                        className={prevClass}
                                        onClick={prevClick}
                                        style={{ cursor: 'pointer', padding: '0.75rem 1.25rem', borderRadius: '6px', backgroundColor: '#007bff', color: '#fff', fontSize: '1rem', fontWeight: 600 }}
                                    >
                                        <a className="page-link" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            &laquo; Previous
                                        </a>
                                    </li>

                                    <li
                                        className={nextClass}
                                        onClick={nextClick}
                                        style={{ cursor: 'pointer', padding: '0.75rem 1.25rem', borderRadius: '6px', backgroundColor: '#007bff', color: '#fff', fontSize: '1rem', fontWeight: 600 }}
                                    >
                                        <a className="page-link" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            Next &raquo;
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )
                }
            </div>
        </div>
    );

    return pager;
};

export default Pager;



// WEBPACK FOOTER //
// ./src/components/common/table/Pager.tsx